

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { snackModule, routerModule, authModule } from '@/store';
import { RouteData } from '@/api/Wordpress';

@Component({
  components: {},
})
export default class extends Vue {
  page: RouteData | null = null;

  get title() {
    if (!this.page) {
      return;
    }
    return this.page.title.rendered;
  }

  get content() {
    if (!this.page) {
      return;
    }
    return this.page.content.rendered;
  }

  get acf() {
    if (!this.page) {
      return;
    }
    return this.page.acf;
  }

  get fp() {
    if (!this.acf || !this.acf.featured_page) {
      return;
    }
    return this.acf.featured_page;
  }

  get fpActive() {
    if (
      this.fp &&
      (this.fp.image || this.fp.title || this.fp.description || this.fp.link)
    ) {
      return true;
    } else {
      return false;
    }
  }

  fpButton(link: string) {
    const url = new URL(link);
    if (window.location.hostname === url.hostname) {
      this.$router.push(url.pathname);
    } else {
      window.location.href = link;
    }
  }

  async mounted() {
    try {
      this.page = await routerModule.getPage(this.$route.path);
      if (this.title) {
        const title = this.title + ' - Gowans Auctions';
        const titleElement = document.getElementsByTagName('title')[0];
        if (titleElement) {
          titleElement.innerHTML = title;
        } else {
          document.title = title;
        }

        authModule.trackPageview({
          gtag: this.$gtag,
          route: this.$route,
          pageTitle: decodeURI(this.title),
        });
      }
    } catch (err) {
      // Not found
      snackModule.showSnackbar('Probably not found');
    }
  }
}
